export const API_URL = 'https://spiced-noon-heliotrope.glitch.me';
export const POSTFIX_PRODUCT = '/api/product';
